import { gql } from '../../__generated__/gql'
export const SONG_REQUEST_ENTRIES_QUERY = gql(`
  query songRequestEntries($q: String, $page: Int) {
    songRequestEntries(q: $q, page: $page) {
      ...songRequestEntryFields
    }
  }
`)
